import Nav from 'components/nav2';
import './privacy.css';
import { _T } from '@dana/components';
import { useState } from 'react';

export default function UserAgreement() {
  const [h, setH] = useState(0);

  return (
    <div className="overflow-scroll h-screen pt-[30px]">
      <Nav close={true} title={_T( '用户服务协议' )}></Nav>
      <div className="user-agreement">
        {/* <div className="head-title">
          <span>
            <strong>{_T( '用户服务协议' )}</strong>
          </span>
        </div> */}

        <div className="head-title content-text">
          {_T( '欢迎您（下称“用户”或“您”）与Dana平台经营者（详见定义条款）共同签署本《用户服务协议》（下称“本协议”）并使用Dana平台服务！各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '本协议包括Dana网站和应用程序上的服务和内容，您的权利、义务和限制，以及Dana的服务条款。为了使用某些Dana服务，您可能须下载软件或内容，并/或同意额外的条款和条件。请您在注册为用户前，仔细阅读本服务条款及其所有附表，以确保您完全理解所有条款。如有问题，请发送电子邮件至cs@Dana.chat，主题为：服务条款。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana可能会不时修改本协议，修改后的协议将在Dana的官方网站上发布并立即生效。您理解并同意，继续使用Dana服务即表示接受修改后的协议。Dana保留自行决定拒绝、限制、暂停或终止您的服务访问权利，并无需事先通知或对此承担任何责任。如果Dana认为您对Dana或其成员构成威胁，Dana有权删除您的个人资料并/或限制、暂停或终止您的访问权利。',
          )}
        </div>
        {/* <div className='head-title content-text'>We are committed to protecting the safety of children and preventing any form of sexual abuse, sexual exploitation and related harmful behaviors. Our applications comply with all applicable laws and regulations as well as Google's "Child Safety Standards" policy, and always put the safety and interests of children first.
                This standard applies to all users and related content, including but not limited to user-generated content, interactive behaviors, reporting mechanisms and content review. Our goal is to create a safe and inclusive social environment, especially for underage users to provide additional protection
                If you find content or behavior involving child sexual abuse or sexual exploitation, please contact us in the following ways:
                Email: cs@Dana.chat
                Online reporting tool: "Report" function in the application
            </div> */}
        <div className="head-title content-text">
          {_T( 'Dana可能包含不准确、不适当、冒犯性或露骨的信息，或者其他违反本协议第5条的信息。Dana对此不承担任何责任或义务。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第一条【接受协议】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '【审慎阅读】您在申请注册流程中点击同意本协议之前，应当审慎阅读（若您为未成年人，应当在监护人陪同下阅读）并充分理解本协议各条款内容，特别是免除或限制Dana平台经营者责任的条款、限制用户权利的条款、法律适用和争议解决条款。免除或限制责任的条款将以黑色加粗标识，您应重点阅读。若您对协议有任何疑问，请勿进行下一步操作，并可向Dana平台客服咨询。Dana平台经营者已依法履行了采取合理的方式提请用户对相关条款进行注意并予以说明的法定义务，并已给予用户充足的时间与充分的选择权来决定是否缔结本协议。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与Dana平台经营者达成一致，成为Dana平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用Dana平台服务。您点击“同意”、“接受”、“注册账号”等含义的按钮，或实际使用Dana平台服务，视为您已完全接受并签署本协议。如果您未申请注册流程，或者在本协议生效前已成为Dana平台的注册用户，则您通过访问和/或使用Dana平台，即视为您表示同意接受本协议的全部内容，否则您无权访问或使用Dana平台。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '【协议修改】在您签署本协议之后，本协议文本可能因国家政策、产品功能和形态、运营方案以及履行本协议的环境发生变化而进行修改。修改后的协议发布在Dana平台上，您可随时查看。若您对修改后的协议有异议的，请立即停止登录并停止使用Dana平台服务。若您登录或继续使用Dana平台，视为认可修改后的协议并同意受其约束。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '【境外用户】若您非新加坡共和国境内用户，您还需同时遵守您所属国家或地区的法律，且您确认，订立并履行本协议不违反您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第二条【定义】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台：指Dana网站及客户端。' )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台服务：Dana平台经营者基于互联网，以包含Dana平台网站、客户端 等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。用户如登录或使用Dana平台经营者关联公司的产品或服务，且该关联产品或服务未设独立用户服务协议及隐私政策的，则本协议同样适用于该部分产品或服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者：SYNCING PTE.LTD.及其关联方。' )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台规则：包括在所有Dana平台网站内已经发布及后续发布的全部规则、解读、公告等内容以及Dana平台各频道、活动页面发布的各类规则、实施细则、产品说明、公告等，如《Dana公会违规管理办法》、《聊天室管理规范》、《用户行为规则》、《信息发布规范》等。您知晓并同意，Dana平台经营者后续单方更新、调整的Dana平台规则均为Dana平台规则不可分割的一部分。Dana平台规则已经充分公示，对平台所有用户均生效并具有约束力。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '用户：下称“您”或“用户”，是指注册、登录、使用、浏览、获取本协议项下服务的个人或组织。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第三条【协议范围】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">{_T( '3.1签约主体' )}</div>
        <div className="head-title content-text">
          {_T( '本协议是您与Dana平台之间关于注册、登录Dana平台以及使用Dana平台服务所订立的协议。本协议对您与Dana平台经营者均具有合同效力。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者是指经营Dana平台的各法律主体。本协议项下，Dana平台经营者可能根据Dana平台的业务调整而发生变更，变更后的Dana平台经营者与您共同履行本协议并向您提供服务，Dana平台经营者的变更不会影响您本协议项下的权益。Dana平台经营者还有可能因为提供新的Dana平台服务而新增，如您使用新增的Dana平台服务的，视为您同意新增的Dana平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。',
          )}
        </div>
        <div className="head-title content-text">{_T( '3.2补充协议' )}</div>
        <div className="head-title content-text">
          {_T( '考虑到互联网服务不断高速发展和演进，您与Dana平台经营者签署的本协议列明的条款并不能完整罗列并覆盖您与Dana所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，Dana平台公示的相关声明及政策、Dana平台规则和协议均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您不同意更新后的内容，请立即停止访问和使用Dana并取消已获得的服务；如您使用Dana平台服务，视为您同意上述补充协议。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong> {_T( '第四条【账户注册与使用】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">{_T( '4.1用户资格' )}</div>
        <div className="head-title content-text">
          {_T( '您确认，在您开始使用/注册程序使用Dana平台服务前，您应当具备所在地区法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '未满12周岁的未成年人不得注册为Dana平台用户，或使用Dana平台服务。已满12周岁的未成年用户，应由其法定代理人阅读、了解并同意本服务条款之所有约定内容及其修改后之内容，始得开始使用或继续使用本服务；如用户开始使用或继续使用本服务，视为其法定代理人已阅读、了解、并同意本服务条款之所有内容及其修改后之内容。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '此外，您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用服务。',
          )}
        </div>
        <div className="head-title content-text">{_T( '4.2账户说明' )}</div>
        <div className="head-title content-text">
          {_T( '当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得Dana平台账户并成为Dana平台用户。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您有权使用您设置或确认的Dana用户名（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录Dana平台。由于您的Dana账户关联您的个人信息及Dana平台商业信息，您的Dana账户仅限您本人使用。未经Dana平台经营者同意，您直接或间接授权第三方使用您Dana账户或获取您账户项下信息的行为所导致的一切责任后果由您自行承担，Dana平台经营者对此不承担任何责任。但如若Dana平台经营者判断您Dana账户的使用可能危及您的账户安全及/或Dana平台信息安全的，Dana平台经营者可拒绝提供相应服务或终止本协议。由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经Dana平台经营者同意，并符合Dana平台规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '为使您更好地使用Dana平台的各项服务，保障您的账户安全，Dana平台经营者可要求您按Dana平台要求及法律规定完成实名认证。如您的账户长期未登录，Dana平台经营者有权予以进行注销、回收、替换或采取删除您账户在Dana平台数据库中的任何记录（包括但不限于注册信息、虚拟物品信息等）等清理措施，您的账户将不能再登录任一Dana平台，相应服务同时终止。Dana在对此类账户进行清理前，将以包括但不限于弹窗、网站公告、站内消息、客户端推送信息等方式通知您。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4.3注册信息管理' )}
        </div>
        <div className="head-title content-text">{_T( '4.3.1真实合法' )}</div>
        <div className="head-title content-text">
          {_T( '在使用Dana平台服务时，您应当按Dana平台页面的提示准确完整地提供您的信息（包括但不限于您的身份证明、联系电话等），以便Dana在必要时与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。您所设置的账户名不得违反法律法规及Dana平台规则关于账户名的管理规定，否则Dana平台经营者可对您的账户名进行暂停使用或注销等处理，并向主管机关报告。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并承诺，您的账户名称、头像和简介等注册信息中不得出现违法和不良信息，没有冒用、关联机构或社会名人，您在账户注册过程中需遵守法律法规、公民合法权益、公共秩序、社会道德风尚和信息真实性等底线。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '如Dana平台经营者发现您在Dana平台中注册或使用的账号等一切自定义名称与其他用户相同而导致无法识别，Dana平台经营者有权要求您修改上述名称，如您在Dana平台经营者要求的时限内未予修改，则Dana平台经营者有权在您自定义的名称后加注识别符号予以区别，您保证无条件同意上述修改。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并认可，Dana平台通过接入第三方服务实现部分产品技术功能（如嵌入程序码、挿件等形式），上述第三方服务仅能接触到其履行职责所需用户个人信息，并保证将采取行业领先的科技来保护您的个人信息安全。您同意并授权，为了更好的为您提供服务以及确保您的账户安全，Dana平台经营者可以根据您提供的手机号码、身份证号码等信息，向电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4.3.2 更新维护' )}
        </div>
        <div className="head-title content-text">
          {_T( '您应当及时更新您提供的信息（包括但不限于注册资料等），确保符合及时、详尽、真实、准确的要求。在法律有明确规定要求Dana平台经营者对部分用户的信息进行核实的情况下，Dana平台经营者将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。您在更改、删除有关信息的同时也可能会造成储存在系统中的文字、图片、视频等丢失，Dana平台经营者对您自主操作导致内容丢失不承担责任。如Dana平台经营者按您最后一次提供的信息与您联系未果、您未按Dana平台经营者的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及Dana平台经营者造成的全部损失与不利后果。Dana平台经营者可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部Dana平台服务，Dana平台经营者对此不承担责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4.3.3账户安全规范' )}
        </div>
        <div className="head-title content-text">
          {_T( '您的账户为您自行设置并由您保管，Dana任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开Dana平台。如您主动通知Dana平台经营者，要求Dana平台经营者采取措施暂停您账号的登录和使用的，Dana平台经营者应当要求您提供并核实与其注册身份信息相一致的个人有效身份信息，否则Dana平台经营者有权拒绝您的上述请求。Dana平台经营者核实您所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，Dana平台经营者有权拒绝用户上述请求。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，均由您自行承担。Dana平台经营者并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您的账户只限您本人使用，不得出借、赠与、出租、未按规定程序转让、售卖或分享他人使用。当您的账户遭到未经授权的使用时，您应当立即通知Dana平台经营者，否则未经授权的使用行为均视为您本人的行为，您将自行承担所有由此导致的损失及后果。除Dana平台经营者存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。如发现任何未经授权使用您账户登录Dana平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知Dana平台经营者。您理解Dana平台经营者对您的任何请求采取行动均需要合理时间，且Dana平台经营者应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除Dana平台经营者存在法定过错外，Dana平台经营者不承担责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4.4 个人信息保护' )}
        </div>
        <div className="head-title content-text">
          {_T( '请参见Dana平台《隐私政策》和《儿童隐私保护声明》。一旦您开始使用我们提供的产品或服务，即表示您已充分理解并同意Dana平台《隐私政策》和《儿童隐私保护声明》。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第五条【Dana平台服务及规范】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '5.1Dana平台服务' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1Dana平台向您提供包括但不限于以下服务：' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.1Dana平台经营者直接所有或运营的任何网站；' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.2Dana平台经营者直接拥有或运营网站的客户端包括但不限于PC、平板、手机、等全部终端的客户端；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.3Dana平台用户个人中心服务；' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.4Dana聊天室服务：创建、进入聊天室参与语音、文字聊天等；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.5Dana消息服务：私聊、群组、好友关系等；' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.6Dana邀约、打赏、发红包服务：对用户发起邀约、打赏、发送红包等；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.1.7Dana平台提供的小游戏和公会创建、加入、管理等其他技术和/或服务（下称“其他技术和服务”）。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（以上服务统称为“Dana平台服务”）。' )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台服务，均仅限于您在Dana平台使用，任何以恶意破解等非法手段将Dana服务与Dana平台分离的行为，均不属于本协议中约定的Dana服务。由此引起的一切法律后果由行为人负责，Dana平台经营者将依法追究行为人的法律责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台网站官方公布的方式为注册、登录、下载、使用Dana服务的唯一合法方式，您通过其他任何方式、任何途径、任何方式获取的Dana服务（包括但不限于账户、道具、下载等）均为非法取得，Dana平台经营者概不承认其效力，且一经发现Dana平台经营者有权立即做出删除、冻结、清零、封号等处理，任何因此导致的一切不利后果均由您自行承担，Dana平台经营者有权依法追究相应人员或机构的法律责任。Dana平台经营者有权向您公告（包括但不限于弹出页面、网站公告、站内消息等方式）以修改、替换、升级与Dana平台服务相关的任何软件。如果您不同意或者不接受Dana平台服务相关软件的修改、替换、升级，请直接拒绝、停止、取消使用Dana平台的一切行为，否则视为您同意并接受Dana平台相关软件的修改、替代、升级，同时该同意并接受的行为仍受本协议约束。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并认可Dana平台虚拟物品包括但不限于虚拟礼物、道具、爵位等，其所有权归Dana平台经营者，用户只能在合乎法律规定的情况下，根据平台规则进行使用消耗，虚拟物品禁止买卖、禁止提现。您理解并认可Dana平台经营者有权根据需要，在平台服务中设立、添加、修改增值服务并发行增值服务代用币。增值服务代用币通过使用实际货币兑换获得，实际货币一经兑换成增值服务代用币，不可退回；增值服务代用币用于购买相关虚拟道具使用权或者接受相关增值服务，不可兑换成为实际货币。平台有权根据用户使用增值服务代用币、打赏或赠送虚拟礼物等实际情况进行相应魅力值奖励，魅力值仅可在平台消耗使用，不可兑换成为实际货币。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台中各类虚拟物品，如对使用期限无特殊标识的，均预设用户可在获得使用权后持续使用，直至相应Dana平台服务终止；如对使用期限有特殊标识的，则其使用期以特殊标识的期限为准，超过使用期的，Dana平台经营者有权不另行通知用户而随时收回其使用权（该使用期限不因任何原因而中断、中止）。在以用户购买虚拟物品的使用权或者以接受其他增值服务作为收费项目的情况下，如超出该虚拟物品的有效使用期限或增值服务的有效服务期限（不管用户是否已经实际使用或者享受服务），或者超出有效使用或服务次数，Dana平台经营者即有权采取措施取消用户对上述虚拟物品的使用权或者停止提供增值服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '重要提示：Dana平台经营者非常重视反欺诈和反洗钱。除了采取适用和必要的法律行动之外，Dana平台经营者有权将用户账户中的每一项经我们判定是使用欺诈手段取得或涉嫌洗钱的虚拟物品和增值服务代用币永久没收、冻结或退回原充值账户；这包括您经由诈欺手段取得的虚拟物品和增值服务代用币，其他用户通过欺诈手段取得后赠送或交易给您的虚拟物品和增值服务代用币，存在交易异常和涉嫌洗钱的虚拟物品和增值服务代用币。如果Dana平台经营者怀疑您持有的虚拟物品或增值服务代用币是以欺诈方式取得（无论欺诈手段是否由您采取），或发现交易不符合常规的可疑账户、虚拟物品、增值服务代用币或资金，Dana平台经营者有权冻结您的账户或账户中相应数量的虚拟物品和增值服务代用币，并提供给您申诉的机会。欺诈和洗钱行为的判定和最终解释权归属于Dana平台经营者。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并认可，鉴于网络服务的特殊性，Dana平台经营者有权随时变更、中断或终止部分或全部的服务（包括收费服务）。Dana平台经营者变更、中断或终止的服务的，应当及时通知用户，并应向受影响的用户提供等值的替代性的服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并认可Dana平台经营者享有如下权利，Dana平台经营者行使如下权利不视为违约，您不追究且豁免Dana平台经营者的相关法律责任：您使用Dana平台网站或Dana平台账户所获得的经验值、等级、关注、订阅、头衔、电子票务、虚拟直播表演房间、虚拟物品及奖励、下载以及Dana平台运营过程中产生并储存于Dana网络数据库的任何资料信息（包括但不限于账户资料信息、直播时长资料信息、虚拟物品资料信息、消费资料信息等）等衍生物（下称“衍生物”），您确认对其不享有所有权（除非Dana平台另有公告说明），Dana平台经营者许可您按照Dana平台规则进行使用，Dana平台经营者对上述衍生物不承担任何赔偿责任。Dana平台经营者有权根据实际情况自行决定收回日期，无需另行通知您亦无需征得您同意。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您同意并保证，不得利用Dana平台服务或其衍生物进行倒卖、转手、置换、抵押有价交易等方式非法牟利。您不会利用Dana平台服务或其衍生物侵犯他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段窃取、盗用他人的账户、虚拟物品等。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并认可，增值服务代用币及虚拟物品禁止提现，且任何非Dana平台官方方式充值、代充、买卖虚拟物品的行为均属禁止行为，一经发现您将被做封号处理，并且账号内的充值金额、虚拟物品及其他增值服务不予退还。如果您通过非Dana平台官方方式向Dana平台账号充值或购买Dana平台的收费服务（包括但不限于购买Dana平台内的虚拟物品的使用权以及接受其他增值服务等各类收费项目）,可能产生风险（包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动）并给您造成经济损失，Dana平台经营者不对您的前述风险和损失承担任何责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '平台为用户间提供的关系标签及相关服务仅出于娱乐互动的目的，并非用户间真实关系的认证，也不鼓励、促使或保证用户间建立任何真实关系往来。您与其他用户之间的关系、联系和纠纷均与平台无关。您与其他用户之间的非法协议和与本协议条款相悖的协议，本平台不予认可，由此产生的纠纷问题平台不承担任何责任及处理义务，相关行为违反本协议规定及平台规则的，Dana平台经营者有权对相关行为给予处罚措施。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.2 自动订阅服务条款' )}
        </div>
        <div className="head-title content-text">
          {_T( '5.2.1 服务说明：Dana平台经营者根据产品需要为用户提供自动订阅服务，自动订阅服务将按照其服务条款和操作说明严格执行，且属于平台服务的一部分。平台有权基于自身运营策略单方面决定和调整自动订阅服务的内容及方式。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.2.2 自动订阅程序' )}
        </div>
        <div className="head-title content-text">
          {_T( '1、在开启自动订阅服务之前，您必须根据真实、准确、合法且有效的个人信息注册成为平台用户，在成功登录平台账户的基础之上开启自动订阅服务，否则平台有权拒绝和取消您的自动订阅。如果您使用第三方账号登录的，您应保证第三方账号和所包含信息的真实、准确、合法及有效性，如因第三方账号原因导致您无法登录的，您应与第三方取得联系进行解决，与Dana平台经营者无关，Dana平台经营者不因此向您退还您已消耗的自动订阅费用并且不进行任何方式的补偿/赔偿。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '2、在您选择自动订阅服务后，即代表您接受Dana平台自动订阅服务和相关使用规则。如您不同意前述任一流程、规则或内容的，您不能进行自动订阅操作。一旦您完成了自动订阅操作，即视为您对所有流程、规则及内容无异议。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '3、您知悉并同意，自动订阅服务仅限于申请账号自行使用；自动订阅服务系网络商品和虚拟商品，采用先收费后服务的方式，消耗的费用是您所购买的虚拟商品/服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质，自动订阅服务一经开启后不可退款和转让。您可以在平台内免费查询您已订阅的虚拟产品/服务、消费记录等，也可以取消对应虚拟产品/服务的自动订阅。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.2.3 自动订阅服务内容及服务费用' )}
        </div>
        <div className="head-title content-text">
          {_T( '1、您理解并同意，鉴于平台虚拟产品/服务的多样性，不同的虚拟产品/服务的自动订阅有不同的费用价格，具体以平台的页面说明和实际提供的为准。Dana平台经营者有权基于自身运营策略变更全部或部分的虚拟产品/服务的自动订阅费用价格、适用的用户设备终端。就前述权益调整，平台将在相应服务页面或以其他合理方式进行通知。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '2、平台自动订阅服务的服务期限，自您自行选择开通自动订阅服务之时起算，至您取消自动订阅服务或帐户内余额不足之时为止。如需取消订阅，请在当前订阅到期24小时前，手动在应用商店中关闭自动订阅功能。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '3、平台自动订阅服务为收费服务，使用该服务需要支付相应的服务费用。Dana平台经营者未提供其他方式获得该服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4、您在选择自动订阅服务之前应仔细核对账号名称、自动订阅的虚拟商品/服务内容、价格、服务期限等信息。自动订阅服务费用在您支付完成后不可转让，且不予退还。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5、自动订阅服务的收费标准由平台根据自身运营策略独立决定，并在相关虚拟商品/服务页面向您展示，若自动订阅服务价格发生调整的，应以平台上公示的现时有效的价格为准，您理解并同意，您继续操作的行为（包括但不限于勾选自动订阅、继续支付或享受自动订阅服务的行为等），视为您知悉并同意调整后的收费标准。',
          )}
        </div>
        <div className="head-title content-text">{_T( '5.3服务规范' )}</div>
        <div className="head-title content-text">
          {_T( 'Dana平台账户的所有权归Dana平台经营者所有，您完成申请注册手续后，获得Dana平台账户的使用权，该使用权仅属于初始申请注册人。您有义务妥善保管在注册并使用Dana平台时获得的账户及密码，并为此组账户及密码登录系统后所开始的一连串行为或活动负责。鉴于网络服务的特殊性，Dana平台不审核是否为您本人使用该组账户及密码，仅审核账户及密码是否与数据库中保存的一致，只要任何人输入的账户及密码与数据库中保存的一致，即可凭借该组账户及密码登陆Dana平台。若用户并非账户初始申请注册人，Dana平台经营者有权在未经通知的情况下冻结、回收该账户且无需向该账户使用人承担任何法律责任，由此导致的包括并不限于您通讯中断、用户资料和虚拟道具等清空等损失由您自行承担。用户账户项下一切活动均视为您本人的行为，您就该等活动负全部责任。若用户账户或用户账户资金的归属出现争议的，Dana平台经营者在发现可疑账户、可疑资金、异常充值、异常交易或收到相关方的投诉后，有权暂时冻结可疑或争议账户和账户资金；争议各方在合理举证期限内提供证据证明账户或账户资金归属，Dana平台经营者依据各方提供的证据判断归属后，合理处理可疑或争议账户和账户资金。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '除非有相关证明，Dana平台经营者将您视为您在Dana平台上传、发布或传输的内容的版权拥有人。您使用Dana平台服务上传、发布或传输内容即代表了您有权且同意，将您在Dana平台上传发布或传输的全部内容（包括但不限于视频、音频，及与本协议事项相关的任何文字、视频、音频等，以下统称“表演成果”）的全部知识产权（包括但不限于著作权、商标权等知识产权以及相关的一切衍生权利）及相关权益，自上传、发布或传输之日起即授权给Dana平台经营者在全球范围内、不可撤销的、永久免费使用，可转授权。协议期内及协议期满后，Dana平台经营者可以任何方式使用上述成果（包括但不限于转授权给第三方）并享有相应的收益，未经Dana平台经营者事先书面同意，您不得自行或提供、授权给任何第三方以任何方式使用及获得任何收益。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '为方便您使用Dana平台经营者和关联公司的其他相关服务，您授权Dana平台经营者将您在账户注册和使用Dana平台服务过程中提供、形成的信息传递给Dana平台经营者关联公司等其他相关服务提供者。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您可以在使用Dana平台服务过程中购买虚拟产品增值服务。若无特殊说明，您通过在Dana平台及其他Dana平台授权的合法方式上获得虚拟产品，具体使用方法、期限等以Dana平台页面中附带的说明或具备以上解说性质的类似官方文档为准。虚拟产品会因用户需求、网站策略调整、用户接受程度等因素随时进行调整，具体信息请以当时的页面说明为准。基于虚拟产品的性质和特征，Dana平台经营者不提供虚拟产品的退货、换货服务。如您消耗所获得的全部虚拟产品，且不将继续使用虚拟产品服务的，则该服务终止。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您应遵守本协议的各项条款，正确、适当地使用本服务，不得扰乱Dana平台秩序，包括但不限于扰乱Dana平台金融秩序（如出售增值服务代用币、虚拟物品等）。除非得到Dana平台经营者的书面授权，您不得将虚拟产品用于商业领域，包括但不限于买卖、置换、抵押或以特定方式使用虚拟产品服务获取不当得利等。需要特别注意的是，如您涉嫌使用不合理手段充值（包括但不限于非法使用信用卡套现）的账户，Dana平台经营者有权依合理判断将您的账户暂时或永久封停。同时，Dana平台经营者保留在任何时候收回该账户、用户名、账户资金、虚拟产品的权利。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '任何用户都应通过正规方式获得Dana虚拟产品服务，一切通过非官方公布方式取得的虚拟产品及其衍生服务均不对Dana发生法律效力，Dana平台经营者有权单方面收回相关虚拟产品并终止相应服务，严重者Dana平台经营者有权对中止或终止您使用Dana平台全部或部分服务、注销账户以及依据法律法规保存有关信息并向有关部门报告等。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您在Dana平台中与他人进行的民事行为引发的法律纠纷，由双方自行处理或报警解决，Dana平台经营者不承担任何责任。Dana平台经营者将积极配和警方的调查，帮助用户维护自身合法权益。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您理解并知晓在使用Dana平台服务时，所接触的内容和信息来源广泛，Dana平台经营者无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。您理解并认可您可能会接触到不正确的、令人不快的、不适当的或令人厌恶的内容和信息，或侵犯他人权利（包括知识产权）的匿名或冒名的信息，该等风险并非平台经营者造成，您不会以此追究Dana平台经营者的相关责任。你可以通过及时向Dana官方客服投诉的方式告知Dana平台，Dana平台经营者有权依法停止传输任何前述内容并采取相应处理，包括但不限于暂停您继续使用Dana的部分或全部服务，保存有关记录并向有关机关报告。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者不对您在Dana平台上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您同意Dana平台经营者在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在Dana平台的任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受Dana平台经营者通过电子邮件、站内消息、手机短信、电话、即时通讯工具、网站公告或其他方式向您发送促销或其他相关商业信息。同时，Dana平台经营者有权在直播间内添加网站logo（或名称）和时间的水印标志。Dana平台经营者将尽力但不保证不影响您的平台体验。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您应当自行约束您在Dana平台上的用户行为，保证自己在线直播、陪玩及表演过程中的人身安全及财产安全。因您自身原因、不可抗力或意外事件或第三方原因造成的人身及财产损失，Dana平台经营者不承担损害赔偿责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '使用Dana平台服务过程中，您需遵守新加坡和所在地区有关计算机及互联网规定的法律、法规。在任何情况下，Dana平台经营者一旦合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您同意并认可，一旦您选择下载Dana软件、购买相关虚拟物品使用权或者接受相关服务，则表明用户已经充分理解并接受相应的收费方式和资费标准。用户同意Dana平台经营者有权决定Dana平台服务的收费方式和资费标准，Dana平台经营者有权就Dana平台各项服务在不同阶段确定不同的收费方式和资费标准，且Dana平台经营者有权根据需要对资费政策随时进行调整。您同意不以任何形式绕开Dana平台的收费方式和资费标准进行在线或线下交易，亦不得通过私下交易的方式逃避Dana平台的收费方式和资费标准。',
          )}
        </div>
        <div className="head-title content-text">{_T( '5.4禁止的内容' )}</div>
        <div className="head-title content-text">
          {_T( '您理解并保证您在Dana平台制作、上传、发布或传输的内容（包括您的账户名称、评论、弹幕等信息）不含有以下内容：',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）泄露国家秘密、危害国家安全、危及国家防务或者损害国家荣誉和利益的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）宣扬恐怖主义、极端主义、种族主义，影响种族和宗教和谐，对种族或宗教团体进行抹黑和讥讽，在种族和宗教之间制造仇恨的内容，亵渎宗教或任何可能冒犯某些信仰的、提倡异端宗教或邪教仪式的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（三）引起人们痛恨和蔑视政府，激发对政府不满的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（四）制造、煽动民族仇恨、民族歧视，或者侵害民族风俗、习惯的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（五）煽动地域歧视、地域仇恨、年龄歧视或性别歧视的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（六）扰乱社会秩序，破坏社会稳定，涉嫌动摇公众对执法部门的信心的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（七）诱导未成年人违法犯罪和渲染及传播淫秽、色情、赌博、暴力、凶杀、恐怖活动或者教唆犯罪的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（八）危害网络安全、利用网络从事危害国家安全或公共安全的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（九）编造或散布谣言、诈骗信息、虚假信息、误导性信息，煽动、惊动、误导部分或全体公众的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（十）以图文、言语、或肢体等任何表达方式侮辱、恐吓、威胁、骚扰、诽谤他人；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（十一）散布污言秽语，损害社会公序良俗的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（十二）实施人肉搜索的或涉及他人隐私、个人信息或资料的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（十三）侵犯他人合法权益 （包括但不限于姓名权、肖像权、名誉权、隐私权、代理权、商标权、著作权、其他知识产权等）的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（十四）私人的、特许的、专有的、攻击性的、恫吓的、暴力的、煽动暴力的、裸露的、歧视性的、不法的、仇恨性的、骚扰性的、猥亵色情的或具性暗示的任何内容，包括任何形式的儿童色情、软色情、虐待和伤害；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（十五）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（十六）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（十七）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '·任何暴力和／或自残、自杀行为内容；' )}
        </div>
        <div className="head-title content-text">
          {_T( '·任何威胁生命健康、利用枪枝刀具等危险器械表演的危及自身或他人人身及／或财产权利的内容；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '·怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '·死亡相关场景：尸体、标本、命案现场。' )}
        </div>
        <div className="head-title content-text">
          {_T( '（十八）使用模糊不清或经改造等无法辨识您个人的照片影片；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（十九）将他人照片图文加以编辑或增删涂盖文字／符号／信息等致有损他人形象或遭致负面评论的行为；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二十）与赌博、堕胎、武器、性服务、买卖非法商品或药物（即使该药物在您的地区为合法药物，非法商品包含但不限于：盗版商品、枪支、烟酒、活体动物等）或其他过激性主题相关的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二十一）有违公共利益、公共道德、公共秩序、公共安全、国家和谐的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二十二）有关法律、行政法规和国家规定禁止的其他内容；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（二十三）Dana判定为负面内容或其他不适合发布或传输的其他内容。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，您将直接承担以上导致的一切不利后果。如因此给Dana平台造成不利后果的，您应负责消除影响，并且赔偿Dana平台经营者因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。',
          )}
        </div>
        <div className="head-title content-text">{_T( '5.5禁止的行为' )}</div>
        <div className="head-title content-text">
          {_T( '您理解并保证不就Dana平台服务进行下列的禁止的行为，也不允许任何人利用您的账户进行下列行为：',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '1) 在注册账户时，或使用Dana平台服务（包括但不限于上传、发布、传播信息等）时，冒充他人或机构，或您讹称与任何人或实体有联系（包括设置失实的账户名称或接入另一用户的账户），或您恶意使用注册账户导致其他用户误认；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '2) 伪造标题或以其他方式操控内容，使他人误认为该内容为Dana所传输；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '3) 将无权传输的内容（例如内部资料、机密资料、侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容等）进行上传、发布、发送电子邮件或以其他方式传输；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4) 上传、张贴、发送电子邮件或以其他方式传送任何未获邀约或未经授权的“垃圾电邮”、广告或宣传资料、促销资料，或任何其他商业通讯；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5) 未经Dana平台经营者明确许可，使用Dana平台服务用于任何商业用途或为任何第三方的利益；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '6) 跟踪或以其他方式骚扰他人 ；' )}
        </div>
        <div className="head-title content-text">
          {_T( '7) 参与任何非法或有可能非法（由Dana判断）的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '8) 赌博、变相赌博或提供赌博资料或透过任何方法诱使他人参与赌博活动；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '9) 使用或利用Dana平台经营者知识产权（包括Dana的商标、品牌、标志、任何其他专有资料或任何网页的布局或设计），或在其他方面侵犯Dana平台经营者任何知识产权（包括试图对Dana平台客户端或所使用的软件进行逆向工程）；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '10) 通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入Dana平台服务、收集或处理通过Dana平台服务所提供的内容；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '11) 参与任何“框架”、“镜像”或其他技术，目的是模仿Dana平台服务的外观和功能；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '12) 干预或试图干预任何用户或任何其他方接入Dana平台服务；' )}
        </div>
        <div className="head-title content-text">
          {_T( '13) 故意散播含有干扰、破坏或限制计算机软件、硬件或通讯设备功能、Dana平台服务、与Dana平台服务相连的服务器和网络的病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意程序码或项目等资料；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '14) 未经他人明确同意，分享或发布该等人士可识别个人身份的资料；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '15) 探究或测试Dana平台服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）Dana平台服务、系统或其他用户的系统的任何安全功能；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '16) 对Dana平台服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '17) 为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量资料和信息；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '18）进行任何破坏Dana平台服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '19）进行任何诸如发布广告、销售商品的商业行为，或者进行任何非法的侵害Dana平台利益的行为，如贩卖Dana平台虚拟产品、外挂等；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '20）恶意抹黑、诋毁Dana平台或其经营者，传播损害Dana平台或其经营者的相关言论或报导，煽动粉丝、网友或其他等网络群体恶意攻击Dana平台或其经营者，无论您的Dana平台账户是否已经封禁或注销；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '21）未经Dana平台经营者书面同意，在任何新闻媒体、自媒体等平台上发布有关Dana平台或其经营者的言论，接受有关Dana平台或其经营者的采访，无论您的Dana平台账户是否已经封禁或注销；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '22) 故意或非故意违反任何相关的新加坡和所在地区的法律、法规、规章、条例等其他具有法律效力的规范。',
          )}
        </div>
        <div className="head-title content-text">{_T( '5.6违反的后果' )}</div>
        <div className="head-title content-text">
          {_T( '若您违反本协议的规定，除了根据其他条款规定受到相应处罚外，还同意承担Dana平台经营者决定的以下一项或几项处罚:',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '1)警告：警告仅仅是针对违反平台规则的用户做出的教育导向，它是用于正常管理平台运行的一种方式。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '2)禁言：关闭违规用户的部分或全部聊天频道，强制暂停用户用户账号的在线对话功能，使用户账号无法与其他用户对话，直到此次处罚到期或是取消。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '3)暂时冻结玩法：将违规用户的服务权限进行限制，限制其部分平台服务操作，直到此次处罚到期或是取消。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '4)永久冻结玩法：将违规用户的服务权限进行限制，限制其部分平台服务操作，且永久不予以解除或释放。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5)暂时禁止登录：违规用户的用户账号将在一定的时间内暂时无法登录使用Dana平台提供的某个或者某几个平台，直到此次处罚到期或是取消。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '6)永久禁止登录：违规用户的用户账号将永久无法登录使用Dana平台服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '7)强制离线：强制让违规用户离开当前服务，结束用户当前服务的执行。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '8)封停账号：暂停或永久停止违规用户账号登录Dana平台服务的权利。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '9)承担法律责任：用户的不当行为对他人或者Dana平台造成损害或者与现行法律规定相违背的，违规用户要依法承担相应的民事、行政或刑事责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '10)解散组织：解散用户成立的包括但不限于帮派、公会、势力等组织。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '11)修改昵称：对于用户包括但不限于人物昵称、帮派名称、聊天室名称、群组名称等可以由用户自主命名的昵称或名称进行强制修改。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '12)暂时限制平台服务行为：违规用户的用户账号将在一定的时间内被限制使用部分平台服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '13)撤销交易：撤销违规交易、将交易双方付出的虚拟物品予以还原。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '14)扣除违规交易所得：扣除违规交易中，违规一方或违规双方所获得的虚拟物品。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '15)交易功能限制：暂时冻结违规交易中，违规一方或违规双方所获得的虚拟物品，并持续考察其在指定期限内的内行为。如指定期限内其无再次违规的，到期自动解冻相应的虚拟物品；如指定期限内其再次违规的，在公司认定其违规行为存在时扣除其被冻结的虚拟物品。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '16)冻结虚拟物品：对违规用户限定其角色的虚拟物品的相关功能，包括但不限于物品的使用、交易、给予等。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '17)收回虚拟物品：对于用户因欺诈或其他违规行为而获取的虚拟物品，包括但不限于虚拟物品作为违约金的一部分进行收回。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '18）其他处罚措施：包括但不限于没收不正当利益（如用户通过不正当途径获得的虚拟物品）作为违约金的一部分、倒扣数值（包括但不限于经验值等）、暂时中断服务等。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.7用户收入及开票服务' )}
        </div>
        <div className="head-title content-text">
          {_T( '用户收入是指用户在Dana平台通过接单和打赏服务获取的收入。平台对接服务方和需求方的聚合和调配，为交易双方提供相关技术服务，平台仅就上述提供的技术服务收取平台服务费。用户同意Dana平台按照确定的收费标准和规则对用户接单和打赏类收入收取平台服务费，平台服务费在每次结算前自动扣除，用户在平台扣除平台服务费后获取用户收入。用户同意通过平台所获得的用户收入均为税前收益，用户应按照相关规定缴纳税款。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '5.8未成年人特别条款' )}
        </div>
        <div className="head-title content-text">
          {_T( '再次进行特别提示，若您是未成年人，在申请注册流程中点击同意本协议之前，应在您的父母或其他监护人监护、指导下审慎阅读本协议，否则无权登录Dana平台并使用Dana平台服务。若您已成年，但不符合所在地区完全民事行为能力人规定的，视同本协议所特指的“未成年人”。特别提示未成年用户理解如因您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担囙此而导致的一切后果。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台重视对未成年人个人信息的保护，未成年用户在填写个人信息时，应加强个人保护意识并谨慎对待，在监护人指导时正确使用Dana平台服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '未成年人用户知悉并同意，使用Dana平台服务应当在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好网络习惯。监护人及他人将手机或其他设备交给未成年人用户使用的，应严格管理好银行卡及其他网络支付工具的支付密码，不代替未成年人进行任何实名认证，如因监管疏忽造成的损失Dana平台经营者不承担任何责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '未成年人用户知悉并同意，Dana平台为更好地保护未成年人，将对未成年人用户使用Dana平台服务时进行一定的限制，包括但不限于服务内容的限制使用、平台收费项目限制使用、平台充值金额的限制等。未成年人使用Dana平台服务时，应当自主选择接受此限制，否则无权登录Dana平台并使用Dana平台服务。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '用户应当慎重发布包含未成年人素材的内容，一经发布，即视为用户同意Dana平台展示未成年人的信息、肖像、声音等，且允许Dana平台经营者依据本协议使用、处理该等与未成年人相关的内容。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong> {_T( '第六条【知识产权】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '除非另有约定或Dana平台经营者另行声明，Dana平台内的所有内容（用户依法享有版权的内容除外）、技术、软件、程序、资料及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利，均归Dana平台经营者或关联公司所有。未经Dana平台经营者许可，任何人不得擅自使用（包括但不限于复制、传播、展示、镜像、上载、下载、修改、出租）。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台的Logo、“Dana”、图形及其组合，以及Dana平台的其他标识、征记、产品和服务名称均为Dana或Dana关联公司的商标，未经Dana平台经营者书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者对Dana平台专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知识产权。未经Dana平台经营者许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯Dana知识产权的行为，否则将承担包括侵权等所有相关的法律责任。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第七条【侵权投诉】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '7.1任何第三方认为，用户利用Dana平台侵害其民事权益或实施侵权行为的，被侵权人有权书面通知Dana平台经营者采取删除、屏蔽、断开链接等必要措施。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '7.2任何第三方认为，Dana平台所涉及的作品、表演、录音录像制品，侵犯自己的合法权益的，可以向Dana平台经营者提交书面通知，要求Dana平台删除该侵权作品，或者断开链接。通知书应当包含下列内容：权利人的姓名（名称）、联系方式和位址；要求删除或者断开链接的侵权作品、表演、录音录像制品的名称和网络位址；权利人的有效权利证明材料。权利人应当对通知书的真实性负责，如果侵权投诉不实，则需承担相应的法律责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '7.3侵权投诉必须包含下述信息：被侵权人的有效权利证明材料，或被侵权作品的原始链接及其它证明材料；侵权信息或作品在Dana平台上的具体名称及链接；侵权投诉人的联络方式，以便Dana平台经营者及时与您取得联系，包括电子邮寄地址、电话号码或手机等；投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该物件侵害本人的合法权益。本人承诺全部投诉信息真实、准确，自愿承担一切后果。”本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '7.4为避免争议，用户理解并同意，在Dana平台服务过程中发生的一切由Dana平台内容独立产生的知识产权纠纷，用户应与Dana平台经营者单独解决。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第八条【用户的违约及处理】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">{_T( '8.1 违约认定' )}</div>
        <div className="head-title content-text">
          {_T( '发生如下情形之一的，视为您违约：' )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）使用Dana平台服务时违反有关法律法规规定的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）违反本协议或本协议补充协议（即本协议第3.2条）约定的。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '为适应互联网行业发展和满足海量用户对高效优质服务的需求，您理解并同意，Dana平台经营者可在Dana平台规则中约定违约认定的程序和标准。如：Dana平台经营者可依据您的用户资料与海量用户资料的关系来认定您是否构成违约，数据的真实性以Dana平台后台数据或经过Dana平台经营者认可的第三方平台数据为准，最终解释权归属于Dana平台经营者；您有义务对您的资料异常现象进行充分举证和合理解释，否则将被认定为违约。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '8.2 违约处理措施' )}
        </div>
        <div className="head-title content-text">
          {_T( '您在Dana平台上发布的内容和信息构成违约的，Dana平台经营者可根据相应规则立即对相应内容和信息进行删除、屏蔽等处理或对您的账户进行暂停使用、查封、冻结或清空虚拟物品、注销等处理。您在Dana平台上实施的行为，或虽未在Dana平台上实施但对Dana平台及其用户产生影响的行为构成违约的，Dana平台经营者可依据相应规则对您的账户执行限制参加活动、中止向您提供部分或全部服务（如查封虚拟表演房间、冻结或清空虚拟物品、扣划违约金等）处理措施。如您的行为构成根本违约的，Dana平台经营者可查封您的账户，终止向您提供服务。如您的账户被查封，您账户内虚拟产品将被清空，相关虚拟产品服务将被终止提供。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '如果您在Dana平台上的行为违反相关的法律法规，Dana平台经营者可依法向相关主管机关报告并提交您的使用记录和其他信息。同时，Dana平台经营者可将对您上述违约行为处理措施信息以及其他经行政或司法机关生效法律文书确认的违法信息在Dana平台上予以公示。除此之外，Dana平台经营者可依据相关法律法规规定，对您进行黑名单管理和信用管理，提供与信用等级挂钩的管理和服务，若您被纳入黑名单，有权对纳入黑名单的您采取禁止重新注册账号的措施，并及时向相关部门报告。',
          )}
        </div>
        <div className="head-title content-text">{_T( '8.3赔偿责任' )}</div>
        <div className="head-title content-text">
          {_T( '如您的行为使Dana平台经营者及/或其关联公司遭受损失（包括但不限于自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿Dana平台经营者及/或其关联公司的上述全部损失。如您的行为使Dana平台经营者及/或其关联公司遭受第三人主张权利，Dana平台经营者及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。',
          )}
        </div>
        <div className="head-title content-text">{_T( '8.4特别约定' )}</div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者负责"按现状"和"可得到"的状态向您提供Dana平台服务。Dana平台经营者依法律规定承担相应义务，但无法对由于信息网路设备维护、连接故障，计算机、通讯或其他系统的故障，黑客活动、计算机病毒、电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者不担保控制或提供的服务在所有国家或地区是适当的、可行的，任何在其他司法辖区使用Dana平台服务的用户应自行确保其遵守当地的法律法规，Dana平台经营者对此不承担任何责任',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第九条【协议的变更】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者可根据国家法律法规变化及Dana平台服务变化的需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过本协议第十条约定的方式通知您。更新后的协议条款一旦公布即代替原来的协议条款',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '如您对变更事项不同意的，您应当于变更事项确定的生效之日起停止使用Dana平台服务；如您在变更事项生效后仍继续使用Dana平台服务，则视为您同意已生效的变更事项。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong> {_T( '第十条【通知】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '您同意Dana平台经营者以以下合理的方式向您送达各类通知、资讯、通讯或联系请求：',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）公示的文案，包括且不限于修改后的《用户服务协议》；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）Dana平台站内消息、弹出消息、客户端推送的消息；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（三）根据您预留于Dana平台的联系方式发出的电子邮件、手机短信、电话、即时通讯工具消息、函件等；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( 'Dana平台经营者通过上述方式向您发出通知，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '对于在Dana平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于法院、仲裁机构）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书和仲裁文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在Dana平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第十一条【协议/服务的终止】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '11.1 终止的情形' )}
        </div>
        <div className="head-title content-text">
          {_T( '您有权通过以下任一方式终止本协议：' )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）在满足Dana平台网站公示的账户注销等清理条件时您通过网站注销您的账户的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）变更事项生效前您停止使用并明示不愿接受变更事项的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（三）您明示不愿继续使用Dana平台服务，且符合Dana平台终止条件的。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '出现以下情况时，Dana平台经营者可以本协议第十条的所列的方式通知您中止或终止本协议且不承担任何责任：',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）您违反本协议约定，Dana平台经营者依据违约条款终止本协议的',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）您转让本人账户、盗用他人账户、提供虚假注册身份信息、发布违禁内容和信息、骗取他人财物、采取不正当手段谋利等行为，Dana平台经营者依据Dana平台规则对您的账户予以查封的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（三）除上述情形外，因您多次违反Dana平台规则相关规定且情节严重，Dana平台经营者依据Dana平台规则对您的账户予以查封的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（四）您的账户被Dana平台经营者依据本协议进行注销等清理的；' )}
        </div>
        <div className="head-title content-text">
          {_T( '（五）您在Dana平台有侵犯他人合法权益或其他严重违法违约行为的；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（六）其它根据相关法律法规Dana平台经营者应当终止服务的情况。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '11.2 协议终止后的处理' )}
        </div>
        <div className="head-title content-text">
          {_T( '本协议终止后，除法律有明确规定外，Dana平台经营者无义务向您或您指定的第三方披露您账户中的任何信息。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '本协议终止后，Dana平台经营者享有下列权利：' )}
        </div>
        <div className="head-title content-text">
          {_T( '（一）停止收集和使用您的个人信息，但可继续保存您留存于Dana平台的其他内容和信息；',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '（二）对于您过往的违约行为，Dana平台经营者仍可依据本协议向您追究违约责任。',
          )}
        </div>
        <div className="head-title tips">
          <span>
            <strong>{_T( '第十二条【法律适用、管辖与其他】' )}</strong>
          </span>
        </div>
        <div className="head-title content-text">
          {_T( '本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用新加坡共和国法律，不考虑法律选择原则；如法律无相关规定的，参照商业惯例及/或行业惯例。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '您因使用Dana平台服务所产生及与Dana平台服务有关的争议，由Dana平台经营者与您协商解决。协商不成时，任何一方均应提交北京国际仲裁中心，并由其根据北京国际仲裁中心的仲裁规则进行仲裁。仲裁地点为北京，仲裁语言应为中文。',
          )}
        </div>
        <div className="head-title content-text">
          {_T( '本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性',
          )}
        </div>
        <div
          style={{
            height: '100px',
          }}
        ></div>
      </div>
    </div>
  );
}
